import {storage} from "@/main";

export const firebaseStorage = {

  methods: {
    getExtension(fname) {
      return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    createUploader(file) {
      let _URL = URL || window.webkitURL
      return {
        show: true,
        file: file,
        name: file?.name || null,
        percent: 0,
        src: _URL.createObjectURL(file),
        url: '',
        status: 'ready',
        error: ''
      }
    },
    createRefObj(url) {
      return {
        src: url,
        url: url,
        percent: 100,
        status: "success"
      }
    },
    uploadToFirebaseStorage(uploader) {
      this.$store.commit('set', ['isLoading', true])
      return new Promise((resolve, reject) => {
        let ext = this.getExtension(uploader.name);
        let name = this.uuidv4() + "." + ext
        const imageStorageRef = storage.ref('admin/' + name);
        imageStorageRef.put(uploader.file).on('state_changed', snapshot => {
            uploader.status = "uploading";
            uploader.percent = (snapshot.bytesTransferred / snapshot.totalBytes) * 99;
          }, error => {
            uploader.status = "error";
            uploader.error = error;
            this.$store.commit('set', ['isLoading', false])
            reject(error);
          }, async () => {
            uploader.url = await imageStorageRef.getDownloadURL()
            uploader.percent = 100;
            uploader.status = "success";
            this.$store.commit('set', ['isLoading', false])
            resolve(uploader.url);
          }
        );
      })
    },
  }
}
